export default "__VITE_ASSET__BDfeBl0Y__"